import React from 'react';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const FestivosDescriptions = ({ festivosDescriptions = [] }) => {
  const { t } = useTranslation();
  
  // Agrupar descripciones por tipo
  const descriptionsByType = {};
  festivosDescriptions.forEach(festivo => {
    const tipo = festivo.tipo || 'festivo';
    if (!descriptionsByType[tipo]) {
      descriptionsByType[tipo] = [];
    }
    descriptionsByType[tipo].push(festivo);
  });

  return (
    <Box sx={{ mt: 4 }}>
      {/* Siempre mostrar la información de clase primero */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
          {t('calendar.class')}
        </Typography>
        <List sx={{ alignItems: 'center' }}>
          <ListItem disablePadding>
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: '#50A579',
                mr: 2,
                flexShrink: 0,
              }}
            />
            <ListItemText
              primary={t('calendar.classDescription', { defaultValue: 'Días con clases programadas' })}
              sx={{
                '& .MuiListItemText-primary': { fontWeight: 'bold' },
              }}
            />
          </ListItem>
        </List>
      </Box>

      {Object.keys(descriptionsByType).length > 0 ? (
        Object.entries(descriptionsByType).map(([tipo, festivosList]) => (
          <Box key={tipo} sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
              {t(`calendar.${tipo}`, { defaultValue: tipo.charAt(0).toUpperCase() + tipo.slice(1) })}
            </Typography>
            <List sx={{ alignItems: 'center' }}>
              {festivosList.map((festivo, index) => (
                <ListItem key={index} disablePadding>
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      backgroundColor: festivo.color || '#F44336',
                      mr: 2,
                      flexShrink: 0,
                    }}
                  />
                  <ListItemText
                    primary={festivo.text}
                    secondary={festivo.date}
                    sx={{
                      '& .MuiListItemText-primary': { fontWeight: 'bold' },
                      '& .MuiListItemText-secondary': { color: 'text.secondary' },
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        ))
      ) : null}
    </Box>
  );
};
